
const videoTriggers = document.querySelectorAll( 'button[data-plays-video]' );
videoTriggers.forEach( ( button ) => {
    button.addEventListener( 'click', async () => {
        const vidId = button.getAttribute( 'aria-controls' );
        const video = /** @type {HTMLVideoElement}*/( document.querySelector( `video#${vidId}` ) );
        if ( !video ) return;

        video.play();
        video.setAttribute( 'controls', 'true' );

        const anim = button.animate( [
            { opacity: 0 },
        ], {
            duration: 300,
            easing: 'ease-in-out',
            fill: 'forwards',
        } );
        await anim.finished;
        button.remove();

    } );
} );
